import { render, staticRenderFns } from "./TenderForm.vue?vue&type=template&id=14205f5c&"
import script from "./TenderForm.vue?vue&type=script&lang=js&"
export * from "./TenderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports